import { render, staticRenderFns } from "./guardia.vue?vue&type=template&id=63fa7d4d&scoped=true&"
import script from "./guardia.vue?vue&type=script&lang=js&"
export * from "./guardia.vue?vue&type=script&lang=js&"
import style0 from "./guardia.vue?vue&type=style&index=0&id=63fa7d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa7d4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VIcon,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle})
